/* eslint-disable no-tabs */
import React, { useRef } from 'react';
import { Grid, InputLabel, TextField, InputAdornment } from '@mui/material';
import { withRouter } from 'react-router-dom';

import MultiSelect from '../../common/multi-select';

function BaseCreateDynamicRunContent({
  currentRun,
  runTypeOptions,
  handleChangeType,
  showDeployQuantity,
  handleCountChange,
  deployableVehicles,
  handleZonesChange,
  zoneOptions,
  styles,
}) {
  const scrollContainerRef = useRef(null);

  const handleOnSelectOpen = () => {
    setTimeout(() => {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    });
  };

  return (
    <Grid style={styles.flexRow}>
      <Grid item container style={styles.content} xs={10} ref={scrollContainerRef}>
        <Grid item xs={12}>
          <InputLabel sx={{ pt: '3%', pb: '2%' }}>
            Run Type
          </InputLabel>
          <MultiSelect
            isSingle
            placeholder="Select Run Type"
            label="Run Type"
            value={[currentRun.type] || []}
            options={runTypeOptions}
            handleChange={handleChangeType}
          />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <InputLabel>Scooters ready to deploy</InputLabel>
            <TextField
              margin="dense"
              name="deployableQuantity"
              type="number"
              placeholder="0"
              variant="standard"
              value={deployableVehicles.length}
              disabled
            />
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={6} sx={{ mt: 2 }}>
              {showDeployQuantity && (
              <div>
                <InputLabel>Quantity to deploy</InputLabel>
                <TextField
                  margin="dense"
                  name="deployCount"
                  type="number"
                  placeholder="--"
                  variant="standard"
                  value={currentRun.deployCount || ''}
                  InputProps={{ inputProps: { min: 1 } }}
                  onChange={handleCountChange}
                  error={currentRun?.deployCount < 1}
                />
              </div>
              )}
            </Grid>
          </Grid>
          {!showDeployQuantity && (
            <Grid item xs={6} sx={{ mt: 2 }}>
              <InputLabel>Number of Vans</InputLabel>
              <TextField
                autoFocus
                fullWidth
                margin="none"
                type="number"
                variant="standard"
                name="vanCount"
                value={currentRun?.vanCount || ''}
                error={currentRun?.vanCount < 1}
                InputProps={{ inputProps: { min: 1 } }}
                onChange={handleCountChange}
              />
            </Grid>
          )}
          <Grid item xs={12} sx={{ mt: 2 }}>
            <InputLabel>Shift Length</InputLabel>
            <TextField
              margin="dense"
              name="duration"
              type="number"
              placeholder="--"
              variant="standard"
              value={currentRun?.duration || ''}
              InputProps={{
                inputProps: { step: 0.5, min: 0.5, max: 12 },
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{ '&.MuiInputAdornment-root': {
                      marginLeft: 2, paddingRight: 6,
                    } }}
                  >
                    hours
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              onChange={handleCountChange}
              error={currentRun?.duration < 0.5 || Number.isNaN(currentRun?.duration)}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel sx={{ pt: '3%', pb: '2%' }}>
              Special events in
            </InputLabel>
            <MultiSelect
              placeholder="Select Locations"
              value={currentRun?.zones || []}
              options={zoneOptions}
              handleChange={handleZonesChange}
              onMenuOpen={handleOnSelectOpen}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const CreateDynamicRun = withRouter((BaseCreateDynamicRunContent));
export { BaseCreateDynamicRunContent, CreateDynamicRun };
